const Toast = ({ toast }) => {
  return (
    <div style={{
      position: 'fixed',
      bottom: 90,
      left: '50%',
      transform: 'translateX(-50%)',
      background: toast.error ? 'var(--red)' : 'var(--green)',
      color: 'white',
      padding: '11px 22px',
      borderRadius: 100,
      fontWeight: 700,
      fontSize: 13,
      zIndex: 9999,
      whiteSpace: 'nowrap',
      animation: 'fadeUp 0.3s ease',
      boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
    }}>
      {toast.message}
    </div>
  )
}

export default Toast
